<template>
    <div login :class="{ dimOpen: isDim }">
        <MercenaryHeader :title="'로그인 및 보안'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>

        <div style="flex:1; padding:12px; background-color: #f5f5f5;">
            <div style="color:#210F03; font-size: 16px; font-weight:500; margin-top:20px;">로그인 정보</div>
            <div class="container" style="margin-top:8px;">
                <div>
                    <div class="label">{{is_social_login ? '소셜로그인' : '이메일'}}</div>
                    <div class="contents">{{ display_id }}</div>
                </div>
            </div>

            <!--<div class="container" @click="() => { }">-->
                <!--<div>-->
                    <!--<div class="label">비밀번호</div>-->
                    <!--<div class="contents">마지막 변경일 : {{ this.$GlobalStore.loginInfo().password_update_date | agoDateStr }}</div>-->
                <!--</div>-->
                <!--<template v-if="!is_social_login">-->
                    <!--<div class="horizontal_line" style=""></div>-->
                    <!--<div style="font-size:14px; font-weight:500; color:var(&#45;&#45;color-main)" @click="editPageOpen('phone_auth'); $Util.sendEventClick('활동및설정_로그인및보안_재설정')">재설정하기</div>-->
                <!--</template>-->

            <!--</div>-->

            <div class="container">
                <div>
                    <div class="label">가입일</div>
                    <div class="contents">{{ $Util.getYYYMMDDHangulStr($GlobalStore.loginInfo().reg_date) }}</div>
                </div>
            </div>

            <div class="container" @click="() => { }">
                <!--<div>-->
                    <!--<div class="label">비밀번호</div>-->
                    <!--<div class="contents">마지막 변경일 : {{ this.$GlobalStore.loginInfo().password_update_date | agoDateStr }}</div>-->
                <!--</div>-->
                <!--<div class="horizontal_line" style=""></div>-->
                <div>
                    <div class="" style=" font-size:14px; font-weight:500;" @click="() => { confirmWithdrawal(); $Util.sendEventClick('활동및설정_로그인및보안_회원탈퇴') }">계정삭제하기</div>
                    <div class="contents" style="font-size:14px; font-weight:500; color:var(--color-main); margin-top:15px;" @click="() => { logout(); }">로그아웃하기</div>
                </div>
            </div>

        </div>

        <!--<section class="login">-->
        <!--<div class="content-detail">-->
        <!--<ul>-->
        <!--<li>-->
        <!--<h3>로그인</h3>-->
        <!--<p class="tit">계정</p>-->
        <!--<span>{{ display_id }}</span>-->
        <!--</li>-->
        <!--<li>-->
        <!--<p class="tit">비밀번호</p>-->
        <!--&lt;!&ndash;<a class="change" @click="editPageOpen('change'); $Util.sendEventClick('gsc_change_password')">변경</a>&ndash;&gt;-->
        <!--<a class="change" v-if="!is_social_login" @click="editPageOpen('phone_auth'); $Util.sendEventClick('마이_로그인보안_비밀번호_재설정')">재설정</a>-->

        <!--<span>마지막 수정일 : {{ this.$GlobalStore.loginInfo().password_update_date | agoDateStr }}</span>-->
        <!--</li>-->
        <!--<li>-->
        <!--<div class="account">-->
        <!--<h3>계정</h3>-->
        <!--<div @click="accountDisabled(); $Util.sendEventClick('마이_로그인보안_계정_비활성화_페이지_이동')" style="color: #606060;">{{ this.$GlobalStore.loginInfo().inactive == '1' ? '계정 활성화' : '계정 비활성화' }}</div>-->
        <!--<div @click="withdrawal(); $Util.sendEventClick('마이_로그인보안_회원탈퇴')" style="color: #606060;">회원 탈퇴</div>-->
        <!--<a style="color: #606060;" class="log-toggle" @click="logout();">로그아웃</a>-->
        <!--</div>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</section>-->

        <!--<div class="pop" v-if="active === 'logout'">-->
        <!--<div class="dim"></div>-->
        <!--<div class="inner">-->
        <!--<p class="tit">로그아웃</p>-->
        <!--<p class="txt">잠시 로그아웃할까요?<br> 언제든 다시 로그인할 수 있어요</p>-->
        <!--<div class="btns">-->
        <!--<a class="logout" @click="logout">로그아웃</a>-->
        <!--<a class="cancel" @click="active = ''">취소하기</a>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <CommonPopupFrame :closeCompleteAction="close" closeType="phone_auth" :isOpen="isPhoneAuth">
            <div>
                <div @click="close('phone_auth')" style="padding-top: 16px; padding-left: 20px; padding-bottom: 15px; font-weight: 700; color: #808080;">닫기</div>
            </div>
            <div style="padding: 0 12px;">
                <div v-if="step !== 2" style="text-align: center; margin-top: 40px;">
                    <div style="font-size: 32px;font-weight: 700;line-height: 46.34px;">전화번호 인증</div>
                    <div style="font-weight: 500;line-height: 24px;">가입할 때 입력했던 전화번호를 입력하세요</div>
                </div>
                <div v-else-if="step === 2" style="text-align: center; margin-top: 16px;">
                    <div style="font-size: 32px;font-weight: 700;line-height: 46.34px; margin-bottom: 16px;">비밀번호 재설정</div>
                    <div style="font-weight: 500;line-height: 24px;">사용하는 비밀번호를 바꿉니다</div>
                </div>
                <template v-if="step === 0">
                    <div style="font-size: 14px; font-weight: 500;display: block; margin-top: 40px;">전화번호</div>
                    <div style="margin-top: 8px;">
                        <input type="tel" ref="auth_phone_input" v-model="authPhoneNumber" placeholder="휴대폰 번호 입력" @click="select($event)" style="padding: 12px; background-color: #f5f5f5; border-radius: 12px; border: none; width: 100%;" class="phone_input">
                    </div>
                    <div @click="sendAuthNumber(true)" :class="authPhoneNumber.length === 0 ? 'un_active' : 'active'" class="auth_box">인증번호 보내기</div>
                    <!-- <div @click="() => { step++ }" :class="authPhoneNumber.length === 0 ? 'un_active' : 'active'" class="auth_box">인증번호 보내기</div> -->
                </template>
                <template v-if="step === 1">
                    <div style="font-size: 14px; font-weight: 500;display: block; margin-top: 40px;">전화번호</div>
                    <div style="margin-top: 8px; border-radius: 12px; background-color: #f5f5f5; padding: 12px;">
                        <div style="line-height: 24px; font-weight: 500; border-bottom: 1px solid #ebebeb; color: #606060; padding-bottom: 8px;">{{ authPhoneNumber }}</div>
                        <div style="border-bottom: 1px solid #ebebeb; display: flex; align-items: center;">
                            <input v-model="auth_number" class="phone_input" placeholder="인증번호를 입력하세요" type="tel" style="background-color: #f5f5f5; border: none; width: 100%; padding: 8px 12px; padding-left: 0;">
                            <div @click="checkAuthNumber" :class="auth_number.length === 0 ? 'un_active' : 'active'" style="width: 89px; height: 28px; border-radius: 16px; line-height: 28px; color: #fff; text-align: center; font-size: 12px; font-weight: 500;">확인</div>
                        </div>
                        <div style="display: flex; font-weight: 500; font-size: 12px; justify-content: space-between; align-items: center; padding-top: 8px;">
                            <div style="line-height: 20px; color: #808080;">인증번호가 오지 않았나요?</div>
                            <div @click="sendAuthNumber(false)" style="line-height: 20px; color: var(--color-main);">인증번호 다시 받기</div>
                        </div>
                    </div>
                    <!-- <div @click="checkAuthNumber" :class="auth_number.length === 0 ? 'un_active' : 'active'" class="auth_box">다음</div> -->
                    <div @click="checkAuthNumber" :class="auth_number.length === 0 ? 'un_active' : 'active'" class="auth_box">비밀번호 재설정</div>
                    <!-- <p class="tit" style="padding-top:30px;">문자 메시지를 통해 <span style="color:var(--color-main)">{{ authPhoneNumber }}</span> 번호로<br> 보내드린 인증 코드를 입력해주세요</p>
                    <div class="cert-wrap error" @click="checkFirstTouch" style="border:1px solid var(--color-main);margin-top:20px;">
                        <label><input type="tel" v-model="auth_number1" placeholder="ㅡ" @keyup="goNext($event, 1)" ref="auth_number_input1" style="font-size:20px;"></label>
                        <label><input type="tel" v-model="auth_number2" placeholder="ㅡ" @keyup="goNext($event, 2)" ref="auth_number_input2" style="font-size:20px;"></label>
                        <label><input type="tel" v-model="auth_number3" placeholder="ㅡ" @keyup="goNext($event, 3)" ref="auth_number_input3" style="font-size:20px;"></label>
                        <label><input type="tel" v-model="auth_number4" placeholder="ㅡ" @keyup="goNext($event, 4)" ref="auth_number_input4" style="font-size:20px;"></label>
                        <label><input type="tel" v-model="auth_number5" placeholder="ㅡ" @keyup="goNext($event, 5)" ref="auth_number_input5" style="font-size:20px;"></label>
                        <label><input type="tel" v-model="auth_number6" placeholder="ㅡ" @keyup="goNext($event, 6)" ref="auth_number_input6" style="font-size:20px;"></label>
                    </div> -->

                    <!-- <div style="margin-top:20px; font-size:14px;">문자 메세지가 오지 않았나요?<span @click="sendAuthNumber(false)" style="color:#101010; text-decoration: underline; margin-left:5px; ">다시 보내기</span></div> -->
                </template>

                <template v-if="step === 2">
                    <div style="font-weight: 500; margin-top: 16px; line-height: 24px; font-size: 14px;">새 비밀번호</div>
                    <div style="margin-top: 4px; border-radius: 12px; background-color: #f5f5f5; padding: 12px;">
                        <div style="border-bottom: 1px solid #ebebeb; display: flex; align-items: center;">
                            <input v-model="password1" class="phone_input" placeholder="비밀번호를 입력하세요" type="password" style="background-color: #f5f5f5; border: none; width: 100%; padding: 8px 12px; padding-top: 0; padding-left: 0;">
                        </div>
                        <div style="align-items: center;">
                            <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #808080; margin-top: 8px;">비밀번호 확인</div>
                            <input v-model="password2" class="phone_input" placeholder="비밀번호 확인" type="password" style="background-color: #f5f5f5; border: none; width: 100%; padding: 8px 12px; padding-left: 0; padding-bottom: 0;">
                        </div>
                    </div>
                    <div style="margin-top: 4px;font-size: 12px;font-weight: 500;line-height: 20px; color: #606060">숫자와 영문(대/소문자)가 포함된 8자 이상이어야 합니다.</div>
                    <div @click="changePassword" :class="password1 === '' || password2 === '' ? 'un_active' : 'active'" class="auth_box">재설정하기</div>
                </template>

                <!-- <div class="btn-wrap">
                    <template v-if="step === 0">
                        <a class="btn save" @click="sendAuthNumber(true)">인증하기</a>
                    </template>
                    <template v-else-if="step === 1">
                        <a class="btn save" @click="checkAuthNumber">계속</a>
                    </template>
                    <template v-else-if="step === 2">
                        <a class="btn save" @click="changePassword">저장하기</a>
                    </template>
                </div> -->
            </div>
        </CommonPopupFrame>


        <!--비밀번호변경-->
        <CommonPopupFrame :closeCompleteAction="close" closeType="change" :isOpen="isChange">
            <div class="inner">
                <div class="top-btns type2">
                    <a class="back" @click="close('change')">닫기</a>
                    <h3>비밀번호 변경</h3>
                </div>
            </div>

            <div class="content-detail">
                <h4>새로운 비밀번호로 변경할게요</h4>

                <p class="tit">현재 비밀번호</p>
                <label>
                    <input type="password" v-model="password0" placeholder="비밀번호를 입력하세요">
                </label>

                <p class="tit">새 비밀번호</p>
                <label>
                    <input type="password" v-model="password1" placeholder="비밀번호를 입력하세요">
                </label>

                <p class="tit">비밀번호 확인</p>
                <label>
                    <input type="password" v-model="password2" placeholder="비밀번호를 입력하세요">
                </label>

                <div class="btn-wrap">
                    <a class="btn save" @click="changePassword">저장하기</a>
                </div>
            </div>
        </CommonPopupFrame>

        <CommonPopupFrame :closeCompleteAction="close" closeType="withdrawal" :isOpen="isWithdrawal">
            <div>
                <div @click="close('withdrawal')" style="padding-top: 16px; padding-left: 20px; padding-bottom: 15px; font-weight: 700; color: #808080;">닫기</div>
            </div>
            <div style="margin-top: 16px; padding: 0 12px;">
                <div style="font-weight: 700; font-size: 32px; line-height: 46px; text-align: center;">계정 삭제하기</div>
                <div style="border-radius: 12px; padding: 12px; background-color: #f5f5f5; margin-top: 40px;">
                    <div style="font-size: 14px;font-weight: 700;line-height: 24px;">계정 삭제하기</div>
                    <div style="font-size: 12px;font-weight: 500;line-height: 20px;">사커하우의 모든 서비스 이용을 중지하고 계정을 영구적으로 삭제합니다. 계정 삭제 시 개인정보 및 멤버톡, 스케줄, 하우의 모든 피드들 및 상호작용 데이터가 소멸됩니다. 단, 일부 메타데이터는 사용자 분석 및 알고리즘 형성을 위해 보관될 수 있습니다. 정말로 계정을 삭제할까요?</div>
                </div>
                <div @click="withdrawal" style="width: 310px; margin: 0 auto; margin-top: 60px; height: 63px; line-height: 63px; text-align: center; color: #fff; border-radius: 30px; background-color: #210F03; font-weight: 500;">계정 삭제하기</div>
            </div>
        </CommonPopupFrame>

    </div>
</template>

<script>
import CommonPopupFrame from './CommonPopupFrame';
import { initialRouteStr, TOAST_TYPE } from "../../../Constants";
import ResponseCode from "../../../ResponseCode";
import MercenaryHeader from "../../common/MercenaryHeader";
export default {
    name: "Login",
    components: { MercenaryHeader, CommonPopupFrame },
    data() {
        return {
            isDim: false,
            isChange: false,
            isWithdrawal: false,
            email: '',
            lastDate: 1,
            logStatus: '로그아웃',
            active: '',
            password0: '',
            password1: '',
            password2: '',

            step: 0,
            authPhoneNumber: '',
            isPhoneAuth: false,
            is_first_touch: true,
            auth_number: '',
            auth_number1: '',
            auth_number2: '',
            auth_number3: '',
            auth_number4: '',
            auth_number5: '',
            auth_number6: '',
            intervalDetectChange: null,
        }
    },
    computed: {
        display_id() {
            const id = this.$GlobalStore.loginInfo().id;

            let display_id = '';
            const prefix = id.substr(0, 2);
            if (prefix === 'a_') {
                display_id = '애플 로그인';
            } else if (prefix === 'k_') {
                display_id = '카카오 로그인';
            } else if(prefix === 'n_'){
                display_id = '네이버 로그인';
            } else if(prefix === 'g_'){
                display_id = '구글 로그인';
            } else {
                display_id = id;
                // const id_arr = id.split('@');
                // const first_id = id_arr[0];

                // if (first_id.length > 2) {
                //     display_id = first_id[0] + '*'.repeat(first_id.length - 2) + first_id[first_id.length - 1] + '@' + id_arr[1];
                // }
            }

            return display_id;
        },
        is_social_login() {
            const id = this.$GlobalStore.loginInfo().id;
            const prefix = id.substr(0, 2);
            return (prefix === 'a_' || prefix === 'k_' || prefix === 'n_' || prefix === 'g_');
        }
    },
    methods: {
        editPageOpen(v) {
            if (v === 'change') this.isChange = true;
            if (v === 'phone_auth') this.confirmChangePassword()
            this.isDim = true;
        },
        confirmChangePassword() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">비밀번호 재설정하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>비밀번호를 재설정하여 보안을 높일 수 있습니다.<br>재설정을 진행할까요?</div>`

            this.$GlobalStore.showConfirm(html, () => {
                this.isPhoneAuth = true;
            }, '변경하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
        },
        close(v) {
            if (v === 'change') this.isChange = false;
            if (v === 'withdrawal') this.isWithdrawal = false;
            if (v === 'phone_auth') {
                this.isPhoneAuth = false;
                this.step = 0
            }
            this.isDim = false;
        },
        logToggle() {
            if (this.active === '') {
                this.active = 'logout';
            } else {
                this.active = '';
                this.logStatus = '로그인';
            }
        },
        async logout() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">로그아웃</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>로그아웃을 진행합니다.</div>`

            this.$GlobalStore.showConfirm(html, async () => {
                this.$Util.sendEventClick('활동및설정_로그인및보안_로그아웃')
                const res = await this.$Axios.post('/api/logout');
                if (res.data.code === 0) {
                    sessionStorage.removeItem('CHECK_REVIEW_AND_HISTORY_LIST_TIME');
                    location.href = initialRouteStr;
                } else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, '로그아웃', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })

        },
        back() {
            this.$GlobalStore.closeLastModal()
        },
        accountDisabled() {
            this.$GlobalStore.addModal('AccountDisabled', { inactive: this.$GlobalStore.loginInfo().inactive, completeAction: () => { } })
        },
        confirmWithdrawal() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">계정 삭제하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>계정은 영구적으로 삭제됩니다.<br>계정을 삭제할까요?</div>`

            this.$GlobalStore.showConfirm(html, async () => {
                this.$Util.sendEventClick('활동및설정_로그인및보안_계정삭제')
                this.isWithdrawal = true
            }, '계속하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
            // this.$GlobalStore.addModal('Withdrawal', { completeAction: () => { } })
        },
        withdrawal() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">회원탈퇴</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>정말로 탈퇴하시겠습니까??</div>`
            this.$GlobalStore.showConfirm(html, async () => {
                this.$Util.sendEventClick('마이_로그인보안_회원탈퇴_계정삭제')
                this.$GlobalStore.showProgress()
                const res = await this.$Axios.post('/api/member/delete');
                if (res.data.code === 0) {
                    this.$GlobalStore.closeModalAll()
                    this.$GlobalStore.addModal('CompleteWithdrawal')
                    this.$GlobalStore.hideProgress()
                } else {
                    this.$GlobalStore.showAlert(res.data.msg);
                    this.$GlobalStore.hideProgress()
                }
            }, '탈퇴하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
        },
        async changePassword() {
            //숫자 영문 특문 확인
            const pattern1 = /[0-9]/;				// 숫자
            const pattern2 = /[a-zA-Z]/;			// 문자
            const pattern3 = /[~!@#$%^&*()_+|<>?:{}]/;	// 특수문자

            if ((!pattern1.test(this.password1) || !pattern2.test(this.password1) || !pattern3.test(this.password1)) && this.password1.length < 8) {
                this.$GlobalStore.showAlert('영문, 숫자, 특수문자 조합 8자리 이상 입력해주세요.');
                return
            }

            // if(!this.password0){
            //     this.$GlobalStore.showAlert('현재 비밀번호를 입력해주세요.');
            //     return ;
            // }

            if (!this.password1 || !this.password2) {
                this.$GlobalStore.showAlert('새 비밀번호를 입력해주세요.');
                return;
            }

            if (this.password1 !== this.password2) {
                this.$GlobalStore.showAlert('새 비밀번호가 일치하지 않습니다.');
                return;
            }

            const parameters = {};
            parameters.password = this.password1;
            parameters.phone = this.authPhoneNumber;
            parameters.authNumber = this.auth_number
            // parameters.prev_password = this.password0;
            const res = await this.$Axios.post('/api/auth/change/password', parameters);
            if (res.data.code === 0) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.showToastVer2('비밀변호가 변경되었습니다.', TOAST_TYPE.AMEND);
                this.close('phone_auth');
                // this.$GlobalStore.closeLastModal();
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }

        },
        select(e) {
            setTimeout(() => {
                e.target.select()
            }, 100)
        },
        async sendAuthNumber(is_show_next) {
            if (!this.authPhoneNumber) {
                this.$GlobalStore.showAlert('휴대폰번호를 입력해주세요.');
                return;
            }

            if (this.$GlobalStore.loginInfo().phone !== this.authPhoneNumber) {
                this.$GlobalStore.showAlert(`등록된 휴대폰 번호와 다릅니다. (${this.$GlobalStore.loginInfo().phone})`);
                return;
            }

            const parameters = {};
            parameters.phone = this.authPhoneNumber;
            parameters.duple = '0';

            const res = await this.$Axios.post('/api/auth/number', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {

                if (is_show_next) {
                    this.step = 1;
                } else {
                    this.$GlobalStore.showAlert('전송되었습니다.');
                }

            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        checkFirstTouch() {
            if (this.is_first_touch) {
                this.$refs['auth_number_input1'].focus();
                this.is_first_touch = false;
            }
        },
        goNext(e, i) {
            const idx = parseInt(i);

            //지우기
            if (e.keyCode === 8) {
                if (i === 1) return;
                const nextIdx = idx - 1;
                this['auth_number' + nextIdx] = null;
                this.$refs['auth_number_input' + nextIdx].focus();
                return;
            }

            if (i === 6) {
                this.$refs['auth_number_input6'].blur();
            } else {
                const nextIdx = idx + 1;
                this.$refs['auth_number_input' + nextIdx].focus();
            }
        },
        async checkAuthNumber() {
            // if (test) {
            //     this.step--
            //     return
            // }

            if (this.auth_number === '') {
                this.$GlobalStore.showAlert('인증번호를 입력해주세요');
                return;
            }

            const parameters = {};
            parameters.authNumber = this.auth_number
            parameters.phone = this.authPhoneNumber;

            const res = await this.$Axios.post('/api/auth/check', parameters);
            if (res.data.code === 0) {
                this.step = 2;
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }
    },
    mounted() {
        // this.step = 1;
        this.$Util.setPhoneFormatter(this.$refs.auth_phone_input);
    },
    beforeDestroy() {
        clearInterval(this.intervalDetectChange);
    },
    created() {
        this.logout = this.$Once(this.logout);
        this.changePassword = this.$Once(this.changePassword);

        this.authPhoneNumber = this.$GlobalStore.loginInfo().phone;

        this.intervalDetectChange = setInterval(() => {
            let numbers = '';
            const cnt = 6;

            if (this.auth_number1.trim().length === cnt) {
                numbers = this.auth_number1;
            } else if (this.auth_number2.trim().length === cnt) {
                numbers = this.auth_number2;
            } else if (this.auth_number3.trim().length === cnt) {
                numbers = this.auth_number3;
            } else if (this.auth_number4.trim().length === cnt) {
                numbers = this.auth_number4;
            } else if (this.auth_number5.trim().length === cnt) {
                numbers = this.auth_number5;
            } else if (this.auth_number6.trim().length === cnt) {
                numbers = this.auth_number6;
            }

            if (numbers) {
                this.$nextTick(() => {
                    this.auth_number1 = numbers[0];
                    this.auth_number2 = numbers[1];
                    this.auth_number3 = numbers[2];
                    this.auth_number4 = numbers[3];
                    this.auth_number5 = numbers[4];
                    this.auth_number6 = numbers[5];
                    this.$refs.auth_number_input6.focus();
                })
            }
        }, 100);

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.auth_box {
    margin-top: 20px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

.un_active {
    background-color: #d9d9d9;
    color: #fff;
}

h2,
h3,
h4,
p,
ul {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-block: 0;
    margin-inline: 0;
}

a {
    display: inline-block;
    text-decoration: none;
    color: #101014;
}

h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
    padding: 18px 20px 10px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid;
    border-color: #F5F5F5;
}

h3 {
    font-size: 20px;
    line-height: 29px;
    font-weight: 500;
    display: inline-block;
}

input {
    outline: none;
}

input[type=number]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

[login] {
    overflow: hidden;
}

.dim {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s;
    animation-timing-function: ease-out;
}

.account {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-weight: 500;
    color: #606060;
}

.top-cont {
    width: 100%;
    background: #fff;
    z-index: 1;
}

.top-btns {
    height: 100px;
    border-bottom: 1px solid;
    border-color: #F5F5F5;
    position: relative;
}

.top-btns .back {
    font-size: 0;
    width: 65px;
    height: 53px;
    display: block;
}

.top-btns.type1 .back:after {
    content: '';
    width: 25px;
    height: 29px;
    background: url("~@/assets/images/mypage/ico-back.png")0 0 no-repeat;
    background-size: contain;
    position: absolute;
    left: 20px;
    top: 12px;
}

.top-btns.type1 h2 {
    padding-top: 0;
}

.top-btns.type2 {
    height: 70px;
}

.top-btns.type2 .back {
    position: absolute;
    left: 0;
    top: 17px;
}

.top-btns.type2 .back:after {
    content: '';
    width: 22px;
    height: 22px;
    background: url("~@/assets/images/mypage/ico-close.png")0 0 no-repeat;
    background-size: contain;
    position: absolute;
    left: 20px;
    top: 16px;
}

.top-btns.type2 h3 {
    text-align: center;
    display: block;
    padding-top: 30px;
}

.login .content-detail ul li {
    font-size: 14px;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #F5F5F5;
}

.login .content-detail ul li:last-child {
    border-bottom: none;
}

.login .content-detail ul li p,
.login .content-detail ul li span,
.login .content-detail ul li a {
    color: #606060;
    line-height: 20px;
    font-weight: 500;
}

.login .content-detail ul li span {
    color: #808080;
    font-weight: 400;
}

.login .content-detail ul li a {
    display: block;
    margin-bottom: 20px;
}

.login .content-detail ul li a:last-child {
    margin-bottom: 0;
    text-decoration: underline;
}

.login .content-detail ul li .change {
    position: absolute;
    right: 0;
    top: 20px;
    text-decoration: underline;
}

.content-detail {
    padding: 30px 20px;
    padding-top: 0;
    box-sizing: border-box;
}

.content-detail h4 {
    margin-bottom: 40px;
}

.content-detail .tit {
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
    color: #606060;
    margin-bottom: 6px;
}

.content-detail label {
    border: 1px solid rgb(229, 229, 229);
    border-radius: 5px;
    padding: 10px 12px;
    box-sizing: border-box;
    display: block;
    margin-bottom: 16px;
}

.content-detail label:first-of-type {
    margin-bottom: 35px;
}

.content-detail label input {
    font-size: 16px;
    border: none;
}

.content-detail label input::placeholder {
    color: #bbb;
}

.pop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
}

.pop .dim {
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
}

.pop .inner {
    width: 280px;
    background: #fff;
    border-radius: 12px;
    text-align: left;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 50%;
    margin-left: -140px;
    top: 50%;
    margin-top: -100px;
    padding: 20px;
    box-sizing: border-box;
}

.pop .tit {
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #000;
}

.pop .txt {
    font-size: 15px;
    line-height: 22px;
    color: #606060;
    margin-bottom: 20px;
}

.pop .btns {
    display: flex;
    justify-content: space-between;
}

.pop .btns a {
    font-size: 15px;
    font-weight: 500;
    width: 116px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid #D9D9D9;
    box-sizing: border-box;
}

.pop .btns a.logout {
    border-color: var(--color-main);
}

.edit-page {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 70%;
    z-index: 10;
    background: #fff;
    transform: translateY(100%);
    transition: transform 0.5s;
    animation-timing-function: ease-out;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    padding-bottom: 70px;
    box-sizing: border-box;
}

.btn-wrap {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 30px;
    text-align: center;
}

.btn {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    border: 1px solid;
    border-color: var(--color-main);
    line-height: 44px;
    width: 274px;
    height: 46px;
    border-radius: 23px;
    cursor: pointer;
}

.btn.update {
    color: var(--color-main);
    margin-bottom: 15px;
}

.edit-page.open {
    transform: translateY(0);
}

.dimOpen .dim {
    opacity: 0.5;
    z-index: 5;
}


.phone_input::placeholder {
    color: #BBBBBB;
}

.cert-wrap {
    width: 232px;
    height: 54px;
    border: 1px solid rgb(245, 245, 245);
    border-radius: 5px;
    display: block;
    padding: 0;
    text-align: center;
    overflow: hidden;
}

.cert-wrap label {
    display: inline-block;
    vertical-align: top;
    border: none;
    padding: 0;
}

.cert-wrap input {
    width: 30px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    border: none;
    vertical-align: top;
    color: var(--color-main);
}

.cert-wrap.error input::placeholder {
    color: var(--color-main);
}


.container {
    background-color: white;
    border-radius: 12px;
    padding: 12px;
}

.label {
    font-size: 14px;
    font-weight: bold;
    color: #210F03
}

.contents {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #210F03;
}

.container+.container {
    margin-top: 10px;
}

.horizontal_line {
    height: 1px;
    background-color: #EBEBEB;
    margin: 12px 0px;
}

.save_btn {
    background-color: #f5f5f5;
    display: grid;
    place-items: center;
    border-radius: 12px;
    height: 48px;
    color: #D9D9D9;
}

.save_btn.active {
    color: #210F03;
}
</style>